import { GenericMessage } from "../../lib/messages";
export class EditMessage extends GenericMessage {
}
